<template>
  <div>
    <a v-if="isExternal" :href="item.href" target="_blank" class="btn-social">
      <svg-icon :icon="item.icon" class="icon-2x" />
      <span>{{ item.title | capitalize }}</span>
    </a>
    <router-link v-else :to="item.href" class="btn-social">
      <svg-icon :icon="item.icon" class="icon-2x" />
      <span>{{ item.title | capitalize }}</span>
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    isExternal: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
.btn-social {
  width: 165px;
  height: 60px;
  border: 1px solid $border-color;
  border-radius: $border-radius;
  outline: none;
  margin: 0 5px;
  cursor: pointer;
  margin-bottom: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  background: none;
  display: inline-block;
  text-decoration: none;
  line-height: 57px;
  text-align: center;
  color: $dark;
  transition: background-color 0.2s;

  &:hover,
  &:focus {
    background: $lighten-bg;
  }

  &:active {
    background: $light-bg;
  }

  i {
    margin-right: 5px;
  }

  span,
  i {
    vertical-align: middle;
  }
}
</style>
